import { render } from "./ResponsiveNavLink.vue?vue&type=template&id=2257d9a2"
import script from "./ResponsiveNavLink.vue?vue&type=script&lang=js"
export * from "./ResponsiveNavLink.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__